import { Injectable } from '@angular/core';
import { LogService } from './log.service';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  constructor(private log: LogService) {}

  postMessage(message: any, target?: any, origin?: any) {
    // assumes message recipient is in the same origin as this UI
    const messageOrigin = origin || window.location.origin;
    // this.log.trace('MessageService.postMessage', { message });
    (target ? (window.document[target] || window.parent[target]) : window.parent).postMessage(
      message,
      messageOrigin
    );
  }

  postModalOpenMessage() {
    this.postMessage('modal:open');
  }

  postModalCloseMessage() {
    this.postMessage('modal:close');
  }

  postRedirectMessage() {
    this.postMessage('app:redirect');
  }

  postRefreshMessage() {
    this.postMessage('app:refresh');
  }

  postLogoutMessage() {
    this.postMessage('app:logout');
  }
}
